"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../../../components/Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// React Select has props to be able to clear the selected value, which is not our case
// since we only clear search input value, according to our behavioral pattern
var ClearSearch = function ClearSearch(_ref) {
  var searchValue = _ref.searchValue,
    onClearSearch = _ref.onClearSearch;
  return searchValue ? /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClearSearch,
    className: "flex fixed text-black top-[88px] pt-[4px] right-[22px] justify-center items-start w-[30px] h-[30px]"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "close-16",
    className: "h-[16px] w-[16px]"
  })) : null;
};
var _default = ClearSearch;
exports.default = _default;